/* eslint-disable no-undef */
import React from 'react'; // Importamos React
// import PropTypes from 'prop-types';
import './overlay.styles.css';

export default function OverlayComponent() {
  //  shouldComponentUpdate() {}{
  function handlerClick(event) {
    event.stopPropagation();
    document.getElementById('tpx-display-overlay').innerHTML = '';
    if (document.getElementById('tpx-display-overlay-container')) {
      document.getElementById('tpx-display-overlay-container').style.visibility = 'hidden';
      document.getElementById('tpx-overlay-close').style.visibility = 'hidden';
    }
  }
  return (
    <div className="tpx-display-overlay-container" id="tpx-display-overlay-container">
      <div id={`tpx-display-overlay`} className="tpx-display-overlay"></div>
      <div className="tpx-overlay-close" id="tpx-overlay-close" onClick={handlerClick}>
        x
      </div>
    </div>
  );
}

// OverlayComponent.propTypes = {
//   videoPlayer: PropTypes.object.isRequired,
// };
